import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../../core/config/core.httpclient-utils';

@Injectable()
export class DocmanFileRest {

    constructor(private http: HttpClient) {}

    /**
     * Get file details with relationships: versions, folders, monitoring, and downloads.
     * @param fileId - ID of the file to retrieve.
     */
    getFileDetails(fileId: number): Promise<any> {
        return this.http.get(`/api/docman/${fileId}/file?rel=versions,folders,monitoring,downloads`)
            .toPromise();
    }

    /**
     * Get file content.
     * @param fileId - ID of the file to retrieve content.
     */
    getFileContent(fileId: number): Promise<any> {
        return this.http.get(`/api/docman/${fileId}/file?rel=content`)
            .toPromise();
    }

    /**
     * Delete a file version.
     * @param fileVersionId - ID of the file version to delete.
     */
    deleteFileVersion(fileVersionId: number): Promise<any> {
        return this.http.delete(`/api/docman/${fileVersionId}/version`)
            .toPromise();
    }

    /**
     * Delete a file.
     * @param fileId - ID of the file to delete.
     */
    deleteFile(fileId: number): Promise<any> {
        return this.http.delete(`/api/docman/${fileId}/file`)
            .toPromise();
    }

    /**
     * Save a new file version.
     * @param fileId - ID of the file.
     * @param fileVersionData - Data of the file version to save.
     */
    saveFileVersion(fileId: number, fileVersionData: any): Promise<any> {
        return this.http.post(`/api/docman/${fileId}/version`, fileVersionData)
            .toPromise();
    }

    /**
     * Save file settings.
     * @param fileId - ID of the file to save.
     * @param fileData - File settings data to save.
     */
    saveFileSettings(fileId: number, fileData: any): Promise<any> {
        return this.http.post(`/api/docman/${fileId}/file`, fileData)
            .toPromise();
    }

    /**
     * Rename a file.
     * @param fileId - ID of the file to rename.
     * @param fileNameData - New file name data.
     */
    renameFile(fileId: number, fileNameData: any): Promise<any> {
        return this.http.post(`/api/filesystem/${fileId}/filename`, fileNameData)
            .toPromise();
    }

    /**
     * Restore a file version.
     * @param fileId - ID of the file.
     */
    restoreFileVersion(fileId: number): Promise<any> {
        return this.http.post(`/api/docman/${fileId}/restore`, {})
            .toPromise();
    }

    /**
     * Upload a binary file.
     * @param fileId - ID of the file to upload.
     * @param fileData - Binary file data to upload.
     */
    uploadBinary(fileId: number, fileData: any): Promise<any> {
        return this.http.post(`/api/docman/${fileId}/binary`, fileData)
            .toPromise();
    }

    /**
     * Unzip a file into a folder.
     * @param fileVersionId - ID of the file version to unzip.
     * @param folderId - ID of the folder where the file will be unzipped.
     */
    unzipFile(fileVersionId: number, folderId: number): Promise<any> {
        return this.http.post(`/api/docman/${fileVersionId}/unzip`, { folderId })
            .toPromise();
    }
}
